module.exports = __webpack_public_path__ + "static-v-shop/1771937137443/img/logo_amex.2dc1fd72.svg";